/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-25 10:23:59
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-01-25 10:37:01
 * @FilePath: \crm-product\found\views\sfa\views\order_manage\branch_company_performance\form\detail.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '@/found/components/table_page';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {
      params: {
        userCode: this.paramsProps.userCode,
        month: this.paramsProps.month,
      },
    };
  },
  methods: {

  },
  created() {
    this.getConfigList('detail-list');
  },
};
